import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface CampaignPausedByServingLimitProps extends BaseTemplateProps {
  campaignName: string
  campaignLink: string
  thresholdPercent: number
  campaignBudget: string
  averageDailySpend: string
}

export const CampaignPausedByServingLimit: TemplateDefinition<CampaignPausedByServingLimitProps> = {
  renderParams: (props: CampaignPausedByServingLimitProps) => ({
    messageKey: 'notificationsDomain.templates.campaignPausedByServingLimit',
    values: {
      campaignName: props.campaignName,
      campaignLink: props.campaignLink,
      thresholdPercent: props.thresholdPercent,
      campaignBudget: props.campaignBudget,
      averageDailySpend: props.averageDailySpend,
    },
  }),
  getLink: (props: CampaignPausedByServingLimitProps): string => props.campaignLink,
}
